import { useOutletContext } from "react-router-dom";
import DashOnuComponent from "../../../../components/dashOnuComponent";
import { useEffect } from "react";

export default function DashOnuCliente() {
  const {
    filterData,
    handleAplicarZoom,
    setLoadingCronometro,
    setCounter,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    apiCliente,
    stopCronometro,
  } = useOutletContext();
  const availableItemsUrl = "/client/dash/schemaKeys";
  const serieTemporalUrl = "/cliente/zabbix/serieTemporal";
  const vlanFallbackUrl = "/client/find/circuitVlan";

  const api = apiCliente;

  return DashOnuComponent({
    filterData,
    handleAplicarZoom,
    setLoadingCronometro,
    setCounter,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    api,
    stopCronometro,
    availableItemsUrl,
    serieTemporalUrl,
    vlanFallbackUrl,
  });
}
